import React from 'react';

import { useDispatch } from '@lumapps/redux/react';
import { captureFocusedTrigger } from '@lumapps/utils/focus/captureFocusedTrigger';

import { actions } from '../ducks/slice';

/** Hook to get the event dialog open state and toggle it. */
export const useEventDialog = () => {
    const dispatch = useDispatch();
    const dialogTriggerRef = React.useRef<HTMLButtonElement | null>(null);
    const [isEventDialogOpen, setIsEventDialogOpen] = React.useState(false);

    const openEventDialog = React.useCallback(() => {
        // Capture the element that opened the dialog so focus can be restored to it on close.
        captureFocusedTrigger(dialogTriggerRef);
        setIsEventDialogOpen(true);
    }, []);

    const closeEventDialog = React.useCallback(() => {
        setIsEventDialogOpen(false);
        dispatch(actions.clearEditedEvent());
    }, [dispatch]);

    return {
        isOpen: isEventDialogOpen,
        openEventDialog,
        closeEventDialog,
        dialogTriggerRef,
    };
};
